import React from "react";

function Congrats() {
  return (
    <div className="bg-[#121127] p-5 mt-[350px] 2xl:mt-[350px] md:mr-32 m-12 mb-64 rounded-md 2xl:h-[500px] 2xl:w-[540px] h-[500px] text-center lg:h-[500px] lg:w-[540px]  z-10 flex flex-col justify-between">
      <div className="md:text-center text-left">
        {" "}
        <h1 className="text-transparent bg-clip-text mt-5 md:px-20 font-bold pb-5 bg-gradient-to-r from-[#8926B6] to-[#EABCFF] sm:text-4xl text-2xl  md:leading-9  text-center sm:text-[26px] md:text-[40px] lg:text-[48px] ">
          Congrats
        </h1>
      </div>
      <p className="text-center text-white tracking-tight letter-spacing:-0.05em font-bold text-4xl 2xl:text-5xl mt-10 mb-8">
        You have successfully minted
      </p>
      <div className="w-5/12 m-auto">
        <p className="text-[#747397] text-center tracking-tight letter-spacing:-0.05em ">
          Your Handitars are now available in your wallet.
        </p>
      </div>
      <button className="rounded bg-[#395e96] m-auto tracking-tight letter-spacing:-0.05em text-white sm:text-[20px] mb-5  text-md font-extrabold sm:py-2 p-1 px-4 sm:px-2 w-8/12 lg:w-7/12 md:w-full sm:w-5/12 hover:scale-105 ">
        Continue
      </button>
    </div>
  );
}

export default Congrats;
